import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DashboardsService {

  private base_url = `/dashboards`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getDashboardWidgetData(dataSource, params?): Observable<any> {
    return this.http
      .get<any>(`${this.base_url}/datasources/${dataSource}`, {params});
  }

  getDashboardWidgetDataPost(dataSource, params?, queryParams?): Observable<any> {
    return this.http
      .post<any>(`${this.base_url}/datasources/${dataSource}`, params, {params: queryParams});
  }

}
